import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Alert, Col, Form, FormFeedback, FormGroup, Label, Row,} from "reactstrap";
import {isNull, map, omit} from "lodash";
import apiUser from "../../apiUser";
import {toast} from "react-toastify";
import Button from "../Button";
import {
  SUPPLIER_MOTO_MAX,
  SUPPLIER_TYPE_ABAK_MOTO, SUPPLIER_TYPE_AFTER_MARKET, SUPPLIER_TYPE_ARGE_KRAKOW, SUPPLIER_TYPE_ARGE_KROSNO, SUPPLIER_TYPE_ARIS_AUTO,
  SUPPLIER_TYPE_AUTO_CENTRUM_MATUSIEWICZ,
  SUPPLIER_TYPE_AUTO_CZESCI_LIPIEC, SUPPLIER_TYPE_AUTO_MAR_TORUN,
  SUPPLIER_TYPE_AUTO_PARTS_100_AB, SUPPLIER_TYPE_AUTO_PLUS, SUPPLIER_TYPE_AUTO_WOJDYLA,
  SUPPLIER_TYPE_AUTOEURO,
  SUPPLIER_TYPE_AUTOLAND,
  SUPPLIER_TYPE_AUTOPARTNERHOLDING,
  SUPPLIER_TYPE_AUTOPARTNERSA,
  SUPPLIER_TYPE_AUTOZATOKA,
  SUPPLIER_TYPE_CAREX,
  SUPPLIER_TYPE_DAN_CAR,
  SUPPLIER_TYPE_DARMA, SUPPLIER_TYPE_DYNEX, SUPPLIER_TYPE_EDPOL,
  SUPPLIER_TYPE_ELIT, SUPPLIER_TYPE_EURO_PARTS, SUPPLIER_TYPE_EXACT_POLAND,
  SUPPLIER_TYPE_GO_WEST,
  SUPPLIER_TYPE_GORDON,
  SUPPLIER_TYPE_HART,
  SUPPLIER_TYPE_INTERCARS,
  SUPPLIER_TYPE_INTERPARTS,
  SUPPLIER_TYPE_INTERTEAM,
  SUPPLIER_TYPE_JADAR_AUTO,
  SUPPLIER_TYPE_JARO_FILTR,
  SUPPLIER_TYPE_KTD,
  SUPPLIER_TYPE_MMOT,
  SUPPLIER_TYPE_MOTO_ART_KIELCE,
  SUPPLIER_TYPE_MOTO_ART_WLOSZCZOWA,
  SUPPLIER_TYPE_MOTOGAMA,
  SUPPLIER_TYPE_MOTORES,
  SUPPLIER_TYPE_MOTOROL, SUPPLIER_TYPE_PARTS_TEAM,
  SUPPLIER_TYPE_POLAMEL,
  SUPPLIER_TYPE_RODON,
  SUPPLIER_TYPE_SAMLI,
  SUPPLIER_TYPE_SIEMIENIEC,
  SUPPLIER_TYPE_SKOPOL,
  SUPPLIER_TYPE_TD_AUTO_KEDZIERZYN,
  SUPPLIER_TYPE_TD_AUTO_OPOLE, SUPPLIER_TYPE_TEMOT,
  SUPPLIER_TYPE_TM_PARTS, SUPPLIER_TYPE_TOMALA, SUPPLIER_TYPE_VANKING, SUPPLIER_TYPE_WAZ_CAR,
  SUPPLIER_TYPE_X_TECH,
  SUPPLIER_TYPES_IMPORT_FROM_API
} from "./SupplierTypes";
import SupplierTypeSelect from "./SupplierTypeSelect";
import SupplierAutoEuroFields from "./SupplierForm/SupplierAutoEuroFields";
import SupplierAutoLandFields from "./SupplierForm/SupplierAutoLandFields";
import SupplierAutoPartnerSaFields from "./SupplierForm/SupplierAutoPartnerSaFields";
import SupplierAutoPartnerHoldingFields from "./SupplierForm/SupplierAutoPartnerHoldingFields";
import SupplierCarexFields from "./SupplierForm/SupplierCarexFields";
import SupplierSamliFields from "./SupplierForm/SupplierSamliFields";
import SupplierJaroFiltrFields from "./SupplierForm/SupplierJaroFiltrFields";
import SupplierMmotFields from "./SupplierForm/SupplierMmotFields";
import SupplierAutoZatokaFields from "./SupplierForm/SupplierAutoZatokaFields";
import SupplierDarmaFields from "./SupplierForm/SupplierDarmaFields";
import SupplierElitFields from "./SupplierForm/SupplierElitFields";
import SupplierGordonFields from "./SupplierForm/SupplierGordonFields";
import SupplierHartFields from "./SupplierForm/SupplierHartFields";
import SupplierInterCarsFields from "./SupplierForm/SupplierInterCarsFields";
import SupplierInterPartsFields from "./SupplierForm/SupplierInterPartsFields";
import SupplierInterTeamFields from "./SupplierForm/SupplierInterTeamFields";
import SupplierMotorolFields from "./SupplierForm/SupplierMotorolFields";
import SupplierAutoCzesciLipiecFields from "./SupplierForm/SupplierAutoCzesciLipiecFields";
import SupplierMotoFirmaFields from "./SupplierForm/SupplierMotoFirmaFields";
import SupplierXTechFields from "./SupplierForm/SupplierXTechFields";
import AppFormCancelButton from "../../componentsReusable/AppFormCancelButton";
import {withTranslation} from "react-i18next";
import SupplierProfiBiznesFields from "./SupplierForm/SupplierProfiBiznesFields";
import SupplierFirma2000Fields from "./SupplierForm/SupplierFirma2000Fields";
import SupplierFalconFields from "./SupplierForm/SupplierFalconFields";
import SupplierNextisFields from "./SupplierForm/SupplierNextisFields";
import SupplierVanKingFields from "./SupplierForm/SupplierVanKingFields";

class SupplierForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      errorsTopLevel: [],
      saving: false,
      data: omit(props.data, ['createdAt', 'updatedAt']),
    };
  }

  onChangeData = (objVal) => {
    this.setState({
      data: {
        ...this.state.data,
        ...objVal,
      }
    })
  }

  onSubmit = () => {
    const formData = new FormData();
    formData.append('data[sessionId]', '')

    map(omit(this.state.data, ['id', 'documentsLastSynchroDate']), (value, key) => {
      formData.append(`data[${key}]`, value);
    })

    this.setState({
      saving: true,
      errors: {},
      errorsTopLevel: [],
    });

    if(this.props.onSavingStart){
      this.props.onSavingStart();
    }

    if(isNull(this.props.data.id)){
      apiUser.suppliers.post(formData)
        .then(data => {
          this.setState({
            saving: false,
          });

          if(this.props.onSavingStop){
            this.props.onSavingStop();
          }

          if(this.props.onCreated){
            this.props.onCreated(data);
          }

          if(this.props.onSaved){
            this.props.onSaved(data);
          }

          toast.success('Dodano nowego dostawcę');
        })
        .catch(res => {
          this.setState({
            saving: false,
            errors: res?.response?.data?.children ?? {},
            errorsTopLevel: res?.response?.data?.errors ?? [],
          });

          if(this.props.onSavingStop){
            this.props.onSavingStop();
          }
        });
    }else{
      apiUser.suppliers.edit(this.props.data.id, formData)
        .then(supplier => {
          this.setState({
            saving: false,
          });

          if(this.props.onSavingStop){
            this.props.onSavingStop();
          }

          if(this.props.onSaved){
            this.props.onSaved(supplier);
          }

          toast.success('Dane zostały zapisane');
        })
        .catch(res => {
          this.setState({
            saving: false,
            errors: res?.response?.data?.children ?? {},
            errorsTopLevel: res?.response?.data?.errors ?? [],
          });

          if(this.props.onSavingStop){
            this.props.onSavingStop();
          }
        });
    }
  }

  render() {
    const {data, saving, errors, errorsTopLevel} = this.state;
    const {submitButton} = this.props;

    return (
      <Form onSubmit={e => {
        e.preventDefault();
        this.onSubmit();
      }}>
        <Row>
          <Col xs={12}>
            {errorsTopLevel.length > 0 && <Alert color="danger" className="text-center">{errorsTopLevel.join(',')}</Alert>}
            {!this.props.supplierSelectHidden && <FormGroup row>
              <Label md={3}>{this.props.t('supplier_select')}</Label>
              <Col md="9">
                <SupplierTypeSelect
                  isDisabled={!!this.props.data.id}
                  type={SUPPLIER_TYPES_IMPORT_FROM_API}
                  value={data.type}
                  onChange={type => this.onChangeData({type})}
                />
                <FormFeedback>{errors.type?.errors?.join('; ')}</FormFeedback>
              </Col>
            </FormGroup>}
            {data.type === SUPPLIER_TYPE_AUTOEURO && <SupplierAutoEuroFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_AUTOLAND && <SupplierAutoLandFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_AUTOPARTNERSA && <SupplierAutoPartnerSaFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_AUTOPARTNERHOLDING && <SupplierAutoPartnerHoldingFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_CAREX && <SupplierCarexFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_SAMLI && <SupplierSamliFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_JARO_FILTR && <SupplierJaroFiltrFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_MMOT && <SupplierMmotFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_AUTOZATOKA && <SupplierAutoZatokaFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_DARMA && <SupplierDarmaFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_ELIT && <SupplierElitFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_GORDON && <SupplierGordonFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_HART && <SupplierHartFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_INTERCARS && <SupplierInterCarsFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_INTERPARTS && <SupplierInterPartsFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_INTERTEAM && <SupplierInterTeamFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_MOTOROL && <SupplierMotorolFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_AUTO_CZESCI_LIPIEC && <SupplierAutoCzesciLipiecFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_X_TECH && <SupplierXTechFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {data.type === SUPPLIER_TYPE_VANKING && <SupplierVanKingFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {[SUPPLIER_TYPE_TM_PARTS, SUPPLIER_TYPE_GO_WEST, SUPPLIER_TYPE_AUTO_WOJDYLA, SUPPLIER_TYPE_AUTO_PLUS,
              SUPPLIER_TYPE_WAZ_CAR, SUPPLIER_TYPE_EXACT_POLAND, SUPPLIER_TYPE_AFTER_MARKET].includes(data.type) && <SupplierMotoFirmaFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {[SUPPLIER_TYPE_RODON, SUPPLIER_TYPE_MOTOGAMA, SUPPLIER_TYPE_KTD, SUPPLIER_TYPE_AUTO_PARTS_100_AB, SUPPLIER_TYPE_DAN_CAR,
              SUPPLIER_TYPE_ARGE_KRAKOW, SUPPLIER_TYPE_ARGE_KROSNO, SUPPLIER_TYPE_PARTS_TEAM, SUPPLIER_TYPE_EURO_PARTS,
              SUPPLIER_TYPE_EDPOL, SUPPLIER_TYPE_DYNEX, SUPPLIER_TYPE_ARIS_AUTO, SUPPLIER_TYPE_TOMALA, SUPPLIER_TYPE_TEMOT, SUPPLIER_MOTO_MAX].includes(data.type) && <SupplierFalconFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {[SUPPLIER_TYPE_MOTORES, SUPPLIER_TYPE_SKOPOL].includes(data.type) && <SupplierFirma2000Fields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {[SUPPLIER_TYPE_ABAK_MOTO, SUPPLIER_TYPE_MOTO_ART_WLOSZCZOWA, SUPPLIER_TYPE_MOTO_ART_KIELCE, SUPPLIER_TYPE_SIEMIENIEC, SUPPLIER_TYPE_POLAMEL,
              SUPPLIER_TYPE_TD_AUTO_KEDZIERZYN, SUPPLIER_TYPE_TD_AUTO_OPOLE, SUPPLIER_TYPE_AUTO_CENTRUM_MATUSIEWICZ, SUPPLIER_TYPE_AUTO_MAR_TORUN].includes(data.type) && <SupplierProfiBiznesFields data={data} errors={errors} onChangeData={this.onChangeData} />}
            {[SUPPLIER_TYPE_JADAR_AUTO].includes(data.type) && <SupplierNextisFields data={data} errors={errors} onChangeData={this.onChangeData} />}
          </Col>
          <Col xs={12} xl={6}>
          </Col>
        </Row>
        {submitButton && <Row className="mt-3">
          <Col className="d-flex justify-content-end">
            <AppFormCancelButton />
            <Button
              className="ml-3"
              color={'primary'}
              loading={saving}
              disabled={!data.type}
              onClick={this.onSubmit}
            >
              <i className="fas fa-save" />
              <span>{this.props.t('common:btn.save')}</span>
            </Button>
          </Col>
        </Row>}
      </Form>
    );
  }
}

SupplierForm.defaultProps = {
  supplierSelectHidden: false,
  data: {
    id: null,
    type: null,
  },
  submitButton: true,
};

SupplierForm.propTypes = {
  supplierSelectHidden: PropTypes.bool,
  data: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
  }),
  submitButton: PropTypes.bool,
  onSaved: PropTypes.func,
  onCreated: PropTypes.func,
  onSavingStart: PropTypes.func,
  onSavingStop: PropTypes.func,
};

export default withTranslation('supplier_form', {withRef:true})(SupplierForm);
